import React, { useState } from 'react';
import cx from 'classnames';

import { BlockWrapper } from '../blockWrapper';
import { PortableTextBlock } from '@modules/portableTextBlock';
import { TicketingPopup } from '../../ui/ticketingPopup';

const Layout = ({
  text,
  image,
  orientation,
  layout,
  whiteText,
  hoverColor,
  blockConfig,
  setPopupOpen,
}) => {
  switch (layout) {
    case 'right':
      return (
        <>
          {hoverColor && (
            <style>
              {`\
            @media(min-width: 1024px){\
                .img-txt:hover .event-${hoverColor?.hex?.replace('#', '')}{\
                    background-color: ${hoverColor?.hex}\
                }\
              }\
            `}
            </style>
          )}

          <BlockWrapper className='prose md:prose-lg img-txt' {...blockConfig}>
            <div className='grid grid-cols-14 relative'>
              <div
                className={cx('self-center', {
                  'col-start-2 col-end-14 lg:col-end-8 lg:mr-12':
                    !orientation || orientation === 'Horizontal',
                  'col-start-2 col-end-15 lg:col-start-5 lg:col-end-15':
                    orientation === 'Vertical',
                  'text-white': whiteText,
                  'text-black': !whiteText,
                  // 'z-1': hoverColor,
                })}>
                {text && (
                  <PortableTextBlock text={text} setPopupOpen={setPopupOpen} />
                )}
              </div>

              <div
                className={cx(
                  'w-full col-start-2 col-end-14 max-w-none self-center row-start-1 overflow-x-hidden',
                  {
                    'lg:col-start-8 lg:ml-12':
                      !orientation || orientation === 'Horizontal',
                    'lg:col-start-5 lg:col-end-11 lg:mr-12 lg:mt-12':
                      orientation === 'Vertical',
                    // 'z-1': hoverColor,
                  },
                )}>
                {image?.figureImage && (
                  <img loading='lazy' src={image?.figureImage?.asset?.url} />
                )}
                {/* {image?.figureImage && <Image className="w-full" {...image.figureImage} />} */}
              </div>
              {/* Removed until further notice */}
              {/* <div className={`${orientation === 'Vertical' && 'hidden'} ${hoverColor && 'lg:block'} hidden absolute ${hoverColor && `event-${hoverColor.hex.replace('#', '')}`} -top-halfGutter -bottom-halfGutter left-halfGutter right-halfGutter transition duration-300 ease-in-out`} /> */}
            </div>
          </BlockWrapper>
        </>
      );

    default:
      return (
        <>
          {hoverColor && (
            <style>
              {`\
           @media(min-width: 1024px){\
                .img-txt:hover .event-${hoverColor.hex.replace('#', '')}{\
                    background-color: ${hoverColor.hex}\
                }\
              }\
            `}
            </style>
          )}

          <BlockWrapper className='img-txt' {...blockConfig}>
            <div className='relative grid grid-cols-14'>
              <div
                className={cx('w-full self-center overflow-x-hidden', {
                  'col-start-2 col-end-14 lg:col-end-8 lg:mr-12':
                    !orientation || orientation === 'Horizontal',
                  'col-start-2 col-end-15 lg:col-start-5 lg:col-end-15':
                    orientation === 'Vertical',
                  // 'z-1': hoverColor,
                })}>
                {image?.figureImage && (
                  <img loading='lazy' src={image?.figureImage?.asset?.url} />
                )}
                {/* {image?.figureImage && <Image className="w-full" {...image.figureImage} />} */}
              </div>

              <div
                className={cx(
                  'col-start-2 col-end-14 prose md:prose-lg max-w-none self-center',
                  {
                    'lg:col-start-8 xl:ml-12 mt-8 lg:mt-0':
                      !orientation || orientation === 'Horizontal',
                    'lg:col-start-5 lg:col-end-11 lg:mr-12 mt-4 lg:mt-12':
                      orientation === 'Vertical',
                    'text-white': whiteText,
                    'text-black': !whiteText,
                    // 'z-1': hoverColor,
                  },
                )}>
                {text && (
                  <PortableTextBlock text={text} setPopupOpen={setPopupOpen} />
                )}
              </div>
              {/* Removed until further notice */}
              {/* <div className={`${orientation === 'Vertical' && 'hidden'} ${hoverColor && 'lg:block'} hidden absolute ${hoverColor && `event-${hoverColor?.hex?.replace('#', '')}`} -top-halfGutter -bottom-halfGutter left-halfGutter right-halfGutter transition duration-300 ease-in-out`} /> */}
            </div>
          </BlockWrapper>
        </>
      );
  }
};

const ImageText = (props) => {
  const [popupOpen, setPopupOpen] = useState(false);
  return (
    <>
      <Layout {...props} setPopupOpen={setPopupOpen} />
      <TicketingPopup popupOpen={popupOpen} setPopupOpen={setPopupOpen} />
    </>
  );
};

export default ImageText;
